import { createAction, props } from '@ngrx/store';

import { Contact } from '@lockton-apps/shared/interfaces';

import { ClientContactsActionTypes } from './types';

export const init = createAction(ClientContactsActionTypes.Init);

export const contactSelected = createAction(
  ClientContactsActionTypes.ContactSelected,
  props<{ contact: Contact }>()
);

export const contactEnabled = createAction(
  ClientContactsActionTypes.ContactEnabled,
  props<{ userId: string }>()
);

export const contactDisabled = createAction(
  ClientContactsActionTypes.ContactDisabled,
  props<{ userId: string }>()
);

export const viewMoreClicked = createAction(
  ClientContactsActionTypes.ViewMoreClicked
);

export const destroyed = createAction(ClientContactsActionTypes.Destroyed);
